module.exports = __webpack_public_path__ + "static/media/photo_6.3bd2aa45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/photo_6.jpg
// module id = 1639
// module chunks = 0